// Capabilities that are available in native app
enum NativeCapability {
  GeolocationWebView = 'GeolocationWebView'
}

export default NativeCapability;
